const defaultTheme = {
  fonts: {
    title: "Poppins, sans-serif",
    main: "Poppins, sans-serif",
  },
  breakpoints: {
    sm: "screen and (max-width: 640px)",
    md: "screen and (max-width: 768px)",
    lg: "screen and (max-width: 1024px)",
    xl: "screen and (max-width: 1280px)",
  },
};

export default defaultTheme;
